import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as M from "materialize-css/dist/js/materialize";
import * as $ from "jquery/dist/jquery";
import { ActivatedRoute, Router } from '@angular/router';
import { ConnectionService } from 'ng-connection-service';

import { ResourcesService } from './resources.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'DelphusPoultry-pwa';
  instance: any;
  instance2: any;
  isConnected = true;
  wifi = 'wifi';
  wifi_icon = 'wifi';
  status = 'Conexión establecida';
  current = 'galpones';
  galpon = 0;
  lote = 0;
  alert_message: string;
  versionFE: any = '';
  versionBE: any = '';

  constructor(
    private http: HttpClient,
    private router: Router,
    private connectionService: ConnectionService,
    public resource: ResourcesService
  ) {
    this.resource.updateOnlineFromLocalStorage()

    this.versionFE = '';
    this.versionamiento();

    this.connectionService.monitor().subscribe(isConnected => {
      this.isConnected = isConnected;
      if (this.isConnected) {
        this.status = 'Conexión establecida'
        this.wifi = 'wifi'
        this.wifi_icon = 'wifi';

        this.resource.updateOnlineFromLocalStorage()
      }
      else {
        this.status = 'Sin internet'
        this.wifi = 'wifi_off'
        this.wifi_icon = 'exclamation-triangle';
      }
      let json = {
        status: this.status,
        wifi: this.wifi,
        wifi_icon: this.wifi_icon
      }
      this.resource.internet = json;
    })

    router.events.subscribe((val) => {
      if (val['url'] != undefined) {
        var ruta = val['url'].split('/')
        if (['pesajes', 'semana', 'agregar-peso'].includes(ruta[1])) {
          this.current = 'pesajes';
          this.lote = ruta[2]
          var corrales = localStorage.getItem('corrales')
          corrales = JSON.parse(corrales)
          for (let i = 0; i < corrales.length; i++) {
            if (corrales[i]['id'] == ruta[3]) {
              this.galpon = corrales[i]['idGalpon']
            }
          }

        } else if (['corrales', 'agregar-corral'].includes(ruta[1])) {
          this.current = 'corrales';
          var lotes = localStorage.getItem('lotes')
          lotes = JSON.parse(lotes)
          for (let i = 0; i < lotes.length; i++) {
            if (lotes[i]['idLote'] == ruta[2]) {
              this.galpon = lotes[i]['idGalpon']
            }
          }
        } else {
          this.current = 'galpones';
        }
        console.log("CAMBIO =======================", ruta)
      }
    });
  }

  versionamiento() {
    this.http.get(this.resource.routePlanta + '/usuario/versionBE/' + this.resource.versionModulo).subscribe(
      (data: any) => {
        this.versionBE = data.version;
      }
    );
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      var elem = document.querySelector('.sidenav');
      this.instance = M.Sidenav.init(elem, {
        edge: 'right'
      });
    }, 0)
  }

  closeSidebar(title) {
    this.title = title;
    this.instance.close();
  }
  goLotes() {
    this.router.navigate(['/lotes/' + this.galpon]);
    this.instance.close();
  }
  goCorrales() {
    this.router.navigate(['/corrales/' + this.lote]);
    this.instance.close();
  }
  confirm(texto) {
    this.instance.close();
    this.alert_message = texto;
    var elem = document.querySelector('#modal3');
    this.instance2 = M.Modal.init(elem);
    this.instance2.open();
  }
  logout() {
    let div = this.router.url.split('/')
    if (div[1] == 'agregar-peso') {
      this.confirm('Tienes información que puedes perder, ¿Estas seguro de cerrar la sesión?')
    } else {
      this.instance.close();
      this.confirmar()
    }
  }
  close() {
    this.instance2.close();
  }
  confirmar() {
    localStorage.removeItem('user');
    localStorage.removeItem('semanas');
    this.router.navigate(['/']);
  }
}
